import type { SVGProps } from "react";
const SvgClueDialogBackgroundPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={763.713}
    height={150.3}
    fill="none"
    fillRule="evenodd"
    stroke="#000"
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    strokeWidth={0.501}
    fontFamily="Times New Roman"
    fontSize={16}
    overflow="visible"
    style={{
      fontVariantLigatures: "none",
    }}
    viewBox="0 -750 572.785 112.725"
    {...props}
  >
    <g stroke="none">
      <path
        fill="#37a8a8"
        d="M5.27-642.546c-7.027-7.027-7.027-18.433 0-25.46l76.421-76.417-.002.001q.113-.117.229-.233a17.94 17.94 0 0 1 12.86-5.267l.003-.002h.001l.002-.001h3.944a18 18 0 0 1 1.758-.072l.003-.002h.001l.002-.001h453.597l.005.013a17.96 17.96 0 0 1 13.421 5.257c7.027 7.027 7.027 18.433 0 25.46q-.133.133-.267.262l.002.003-76.384 76.384c-3.106 3.106-7.066 4.839-11.731 5.175l-.171.075-.562.001h-1.106l-3.739.001h-.067l-.234.073-.562.001h-1.106l-453.345.018a17.95 17.95 0 0 1-12.973-5.269m89.489-107.368.021-.009h-.002zm.022-.009zm5.686-.066.021-.009h-.002zm.022-.009z"
      />
      <path
        fill="#f7e5c5"
        d="m477.51-647.148-1.414-.001-454.822-.009a8.98 8.98 0 0 1-6.766-2.626c-3.513-3.513-3.513-9.217 0-12.73l74.993-74.993.006-.006.005-.004.021-.021-.002.001a8.97 8.97 0 0 1 6.338-2.61l.002-.001h455.992v.002a8.98 8.98 0 0 1 6.414 2.633c3.513 3.513 3.513 9.217 0 12.73l-.191.186-74.667 74.666.002-.001-.164.169a8.97 8.97 0 0 1-5.747 2.615l-1.018-.001-.208.001q.613.042 1.226 0m5.87-2.766.039-.017z"
      />
    </g>
  </svg>
);
export default SvgClueDialogBackgroundPhone;
